import { useContext, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'
import returnsServices from '@/returns/services/services'

import { getSavedEditedAmountsPayload } from './helpers'

const useEditAmounts = ({ setToastInfo }) => {
  const { rmaInfo, setRmaInfo } = useContext(RMAContext)
  const [showEditAmountDrawer, setShowEditAmountDrawer] = useState(false)
  const { loading: gettingRmaAmounts, fetchData: getRmaAmounts } = useFetch(returnsServices.getRmaAmountsSummary, {
    doInitialRequest: false,
  })

  const { fetchData: cancelEditedRmaAmounts } = useFetch(returnsServices.cancelEditedRmaAmounts, {
    doInitialRequest: false,
  })

  const { fetchData: saveEditedRmaAmounts, loading: savingEditedRmaAmounts } = useFetch(
    returnsServices.saveEditedRmaAmounts,
    {
      doInitialRequest: false,
    }
  )

  const closeEditAmountDrawer = async () => {
    try {
      await cancelEditedRmaAmounts({ orderId: rmaInfo?.orderInfo?.id, returnId: rmaInfo?.orderInfo?.returnId })
      setShowEditAmountDrawer(false)
    } catch (err) {
      setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
    }
  }

  const handleOnclickChangeAmounts = async () => {
    try {
      setShowEditAmountDrawer(true)
      const data = await getRmaAmounts({ orderId: rmaInfo?.orderInfo?.id, returnId: rmaInfo?.orderInfo?.returnId })

      setRmaInfo(rmaInfo => ({
        ...rmaInfo,
        orderAmount: {
          ...rmaInfo.orderAmount,
          ...data?.summary,
        },
        orderInfo: {
          ...rmaInfo.orderInfo,
          refund_amounts: data?.refund_amounts,
        },
      }))
    } catch (err) {
      setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
    }
  }

  const onSaveEditAmounts = async info => {
    try {
      const data = await saveEditedRmaAmounts({
        orderId: rmaInfo?.orderInfo?.id,
        returnId: rmaInfo?.orderInfo?.returnId,
        payload: getSavedEditedAmountsPayload(info),
      })

      setRmaInfo(rmaInfo => ({
        ...rmaInfo,
        orderInfo: {
          ...rmaInfo.orderInfo,
          refundType: info.refundMethodSelected,
        },
        orderAmount: {
          ...rmaInfo.orderAmount,
          ...data?.summary,
        },
      }))
      setShowEditAmountDrawer(false)
    } catch (err) {
      setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
    }
  }

  return {
    gettingRmaAmounts,
    handleOnclickChangeAmounts,
    onSaveEditAmounts,
    showEditAmountDrawer,
    closeEditAmountDrawer,
    savingEditedRmaAmounts,
  }
}

export default useEditAmounts
